import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { LeftSidebarComponent } from './components/left-sidebar/left-sidebar.component';
import { MainAreaComponent } from './components/main-area/main-area.component';
import { SharedModule } from '../shared/shared.module';
import { CommonModule } from '@angular/common';
import {AddTooltipPipe, TopBarComponent} from './components/top-bar/top-bar.component';
import { AccessDeniedComponent } from './components/access-denied/access-denied.component';
import { ApprovalsComponent } from './components/flow-management/approvals/approvals.component';
import { ApprovalListComponent } from './components/flow-management/approvals/approval-list/approval-list.component';
import { ApprovalDetailsComponent } from './components/flow-management/approvals/approval-details/approval-details.component';
import { FlowManagementComponent } from './components/flow-management/flow-management.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
  ],
    declarations: [
        LeftSidebarComponent,
        MainAreaComponent,
        TopBarComponent,
        AccessDeniedComponent,
        ApprovalsComponent,
        ApprovalListComponent,
        ApprovalDetailsComponent,
        FlowManagementComponent,
        AddTooltipPipe
    ],
    exports: [
        LeftSidebarComponent,
        MainAreaComponent,
        TopBarComponent,
        AccessDeniedComponent,
        FlowManagementComponent,
        ApprovalsComponent,
        ApprovalListComponent,
        ApprovalDetailsComponent,
    ],
    entryComponents: [
        FlowManagementComponent,
        ApprovalsComponent,
        ApprovalListComponent,
        ApprovalDetailsComponent,
    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA,
        NO_ERRORS_SCHEMA
    ]
})
export class CoreModule { }
